<template>
  <div>
    <va-modal
      v-model="showModal"
      id="leadDetailsModal"
      ref="leadSummaryModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="false"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      :fixedLayout="true">

      <div slot="header" class="d-flex justify--space-between">
        <span :class="{'col-width': isMobile}">
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ leadHeader | capitalize }}</b></span>
          <span :title="$t('optometry.leads.table.has_visual_loss')" v-if="selectedLead.has_visual_loss" class="mr-2">
            <small style="cursor: default">{{$t('optometry.leads.table.vl')}}</small>
          </span>

          <!--
          <span v-if="selectedLead.visualLossResult" class="mr-2">
            <span v-if="selectedLead.hearingLossResult == 'mild'" :title="$t('leads.table.hl_mild') +' (' + Math.max(selectedLead.ht.hl_left, selectedLead.ht.hl_right) + ' dB)'" class="i-evollu-hl-mild" style="vertical-align: text-bottom;"></span>
            <span v-if="selectedLead.hearingLossResult == 'severe'" :title="$t('leads.table.has_hearing_loss') +' (' + Math.max(selectedLead.ht.hl_left, selectedLead.ht.hl_right) + ' dB)'" class="i-evollu-hl-severe" style="vertical-align: text-bottom;"></span>
            <span v-if="selectedLead.hearingLossResult == 'normal'" :title="$t('leads.table.no_hearing_loss', {dbs: Math.max(selectedLead.ht.hl_left, selectedLead.ht.hl_right)})" class="i-evollu-hl-normal" style="vertical-align: text-bottom;"></span>
          </span>
          <span v-if="selectedLead.answers && selectedLead.questionnaire_score < 20" :title="$t('leads.table.questionnaire_low_score') + ' (' + selectedLead.questionnaire_score + ')'" class="i-evollu-questionnaire mr-2" style="vertical-align: text-bottom;"></span>
          <span v-if="selectedLead.questionnaire_score >= 20" :title="$t('leads.table.questionnaire_score') + ' (' + selectedLead.questionnaire_score + ')'" class="i-evollu-questionnaire-danger mr-2" style="vertical-align: text-bottom;"></span>
          <span v-if="selectedLead.hearing_aid" :title="$t('leads.table.hearing_aid')" class="i-evollu-hearing-aid mr-2" style="vertical-align: text-bottom;"></span>-->
        </span>
        <span class="close-modal-button" v-if="isMobile">
          <va-button icon="fa fa-times" @click.prevent="$emit('cancel')"></va-button>
        </span>
      </div>

      <LeadInfo
        class="mb-5"
        :selectedLead="selectedLead"
        @openPrivacyPolicyModal="openPrivacyPolicyModal"/>

      <hr class="separator-lead-details">

      <Questionnaire
        class="mt-5"
        :answers="selectedLead.answers" />
    </va-modal>

    <PrivacyPolicyModal
      v-if="showPrivacyPolicyModal && (selectedLead.privacy_policy || selectedLead.consent_id)"
      :url="handlePrivacyUrl(selectedLead)"
      :is-consent-url="selectedLead.consent_id !== null && selectedLead.consent_id !== ''"
      @cancel="onCancelPrivacyPolicyModal"
    />

    </div>
</template>
<script>

import LeadInfo from '@/components/optometry/leads/LeadInfo'
import PrivacyPolicyModal from '@/components/leads/PrivacyPolicyModal'
import Questionnaire from '@/components/optometry/leads/Questionnaire'
export default {
  components: {
    Questionnaire,
    PrivacyPolicyModal,
    LeadInfo

  },
  props: {
    selectedLead: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      showPrivacyPolicyModal: false
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    handlePrivacyUrl: function (selectedLead) {
      if((selectedLead.consent_id !== null && selectedLead.consent_id !== '') && process.env.VUE_APP_CONSENT_URL) {
        return `${process.env.VUE_APP_CONSENT_URL}v1/consent/${selectedLead.consent_id}`
      }
      return selectedLead.privacy_policy
    },
    openPrivacyPolicyModal: function () {
      this.showModal = false
      this.showPrivacyPolicyModal = true
    },
    onCancelPrivacyPolicyModal: function () {
      this.showPrivacyPolicyModal = false
      this.showModal = true
    },
  },
  computed: {
    isMobile: function () {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches
    },
    leadHeader: function () {
      let header = ''
      if (this.selectedLead && this.selectedLead.title && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.title + ' ' + this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name) {
        header = this.selectedLead.name
      }
      return header
    },
  }
}
</script>
